import React, { useS } from "react";
import claimBlue from "../../assets/images/stuff/claimBlue.png";
import claimed from "../../assets/images/stuff/claimed.png";

const CalimButton = ({ item, setShowDialog, setDialogContent, style }) => {
  const handleClaim = () => {
    setShowDialog(true);
    setDialogContent({
      type: "sticker",
      stickers: item.allStickers,
      week: item.episode,
    });
    setTimeout(() => {
      item.setClaimed(true);
    }, 1000);
  };

  return (
    <img
      src={item.claimed ? claimed : claimBlue}
      alt="claimBlue"
      className={style.claim}
      onPointerUp={handleClaim}
      id={item.claimId}
    />
  );
};

export default CalimButton;
